import * as Yup from "yup";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import { Stack, IconButton, InputAdornment } from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from "../../../components/Iconify";
import { FormProvider, RHFTextField } from "../../../components/hook-form";
// import { postDataApi } from "../../../utils/apis";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  register,
  setIdentitifcationType,
} from "../../../redux/features/authSlice";
import { setCurrentTab } from "../../../Containers/OnBoarding/slice";
import { RegistrationStatus, UserType } from "../../../common/enum";
import Snackbar from "../../../components/Snackbar/Snackbar";
import { useSnackbar } from "notistack";
import { useData } from '../../../Containers/OnBoarding/DataContext';
// ----------------------------------------------------------------------

export default function RegisterForm({ t }) {
  const navigate = useNavigate();
  
  const [open , setOpen] = React.useState(false)
  const [severity , setSeverity] = React.useState("")
  const [message , setMessage] = React.useState("")
  const {enqueueSnackbar} = useSnackbar()
  const { setSharedData } = useData();
  const { sharedData } = useData();

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);

  const RegisterSchema = Yup.object().shape({
    email: Yup.string()
      .email("Insira um e-mail válido")
      .required(t("emailRequired")),
    password: Yup.string()
      .required(t("passwordRequired"))
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.@$!%*#?&])[A-Za-z\d.@$!%*#?&]{9,}$/,
        {
          message:
            "A palavra-passe deve ter no mínimo 8 caracteres, com letras, números e símbolos",
          excludeEmptyString: false,
        }
      ),
    confirmPassword: Yup.string()
      .required(t("pleaseRetypePassword"))
      .oneOf([Yup.ref("password")], t("passwordDonotMatch")),
  });

  const defaultValues = {
    email: "",
    password: "",
    confirmPassword: "",
  };

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setError,
    formState: { isSubmitting },
  } = methods;

  const onClose =React.useCallback (() => {
    setOpen(false);
  },[]);

  const onSubmit = async () => {
    const value = methods.getValues();
    setSharedData({
      data: {},
      identificationType: null,
      UserType: null,
      RegistrationStatus: null,
      businessRegistrationUri: null,
      select1: null,
      select2: null,
      select3: null,
      position: null,
      profileOptionsValue: null,
      profileUri: null,
      bannerUri: null,
      entityTypeOptionsValue: null,
      activityOptionsValue: null,
      mandatedStatementUri: null

    });
    const data = {
      email: value?.email.toLowerCase(),
      password: "" + value?.password,
      userType: UserType.entity,
      status: RegistrationStatus.registering,
      createdBy: null,
    };
    dispatch(setIdentitifcationType(""));
    await dispatch(register({ data }))
      .unwrap()
      .then((response) => {
        if (response.userId !== undefined) {
          navigate("/multistep");
          dispatch(setCurrentTab(0));
        } else {
          enqueueSnackbar({
            message: t("accountAlreadyRegistered"),
            variant: "error",
            // autoHideDuration: 3000
          })
          // alert(t("emailAlreadyExist"));
          // setMessage("accountAlreadyRegistered")
          // setSeverity("error")
          // setOpen(true)
          // navigate("/");
        }
      })
      .catch((error) => {
        setError("email", { type: "AuthFail", message: error.message });
      });
  };

  return (
    <>
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField name="email" label={t("emailAddress")} />

        <RHFTextField
          name="password"
          label={t("password")}
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? t("hidePassword") : t("showPassword")}
                >
                  <Iconify
                    icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                    aria-hidden="true"
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <RHFTextField
          name="confirmPassword"
          label={t("confirmPassword")}
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? t("hidePassword") : t("showPassword")}
                >
                  <Iconify
                    icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                    aria-hidden="true"
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <LoadingButton sx={{
            borderRadius:'4px'
          }}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={loading}
        >
          {t("register")}
        </LoadingButton>
      </Stack>
    </FormProvider>
    <Snackbar 
     open={open}
     severity={severity}
     onClose={onClose}
     message={message}
     t={t}
    />
    </>
  );
}
